// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tu0XvZVffeyqqw {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: var(--ds-radius-large, 8px);
  outline: 0;
  background-color: var(--ds-surface-overlay, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
.F4ycqeb62wUbQq {
  display: grid;
  position: relative;
  grid-template-columns: 32px 1fr 32px;
  align-items: center;
  padding: var(--ds-space-050, 4px) var(--ds-space-100, 8px);
  text-align: center;
}
.F4ycqeb62wUbQq.w2na5dRRFTiC5E {
  display: flex;
  position: static;
  box-sizing: border-box;
  grid: none;
  align-items: center;
  min-height: 40px;
  max-height: 49px;
  margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.RXaG378ipXh0pB {
  display: block;
  position: relative;
  grid-column: 1 / span 3;
  grid-row: 1;
  height: 40px;
  margin: var(--ds-space-0, 0);
  padding: 0 32px;
  overflow: hidden;
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  letter-spacing: -0.003em;
  line-height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.RXaG378ipXh0pB.w2na5dRRFTiC5E {
  display: -webkit-box;
  flex: 1;
  height: auto;
  padding: var(--ds-space-0, 0) var(--ds-space-400, 32px);
  overflow: hidden;
  border: 0;
  line-height: initial;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.aFGD9vtcIAqeiM {
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
  padding: 12px;
  overflow-x: hidden;
  overflow-y: auto;
}
.aFGD9vtcIAqeiM::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.aFGD9vtcIAqeiM::-webkit-scrollbar-button:start:decrement,
.aFGD9vtcIAqeiM::-webkit-scrollbar-button:end:increment {
  display: none;
  background: transparent;
}
.aFGD9vtcIAqeiM::-webkit-scrollbar-track-piece {
  background: var(--ds-background-neutral, #091e420f);
}
.aFGD9vtcIAqeiM::-webkit-scrollbar-track-piece:vertical:start {
  border-radius: var(--ds-radius-small, 4px) var(--ds-radius-small, 4px) 0 0;
}
.aFGD9vtcIAqeiM::-webkit-scrollbar-track-piece:vertical:end {
  border-radius: 0 0 var(--ds-radius-small, 4px) var(--ds-radius-small, 4px);
}
.aFGD9vtcIAqeiM::-webkit-scrollbar-track-piece:horizontal:start {
  border-radius: var(--ds-radius-small, 4px) 0 0 var(--ds-radius-small, 4px);
}
.aFGD9vtcIAqeiM::-webkit-scrollbar-track-piece:horizontal:end {
  border-radius: 0 var(--ds-radius-small, 4px) var(--ds-radius-small, 4px) 0;
}
.aFGD9vtcIAqeiM::-webkit-scrollbar-thumb:vertical,
.aFGD9vtcIAqeiM::-webkit-scrollbar-thumb:horizontal {
  display: block;
  height: 48px;
  border-radius: var(--ds-radius-small, 4px);
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.aFGD9vtcIAqeiM:has(.popover-section-animating) {
  overflow-y: hidden;
}
.aFGD9vtcIAqeiM:focus {
  outline: 0;
}
.aFGD9vtcIAqeiM.BxnW01nt1ospt1 {
  padding-right: var(--ds-space-0, 0);
  padding-left: var(--ds-space-0, 0);
}
.aFGD9vtcIAqeiM.uS2wuOb6bRMSqo {
  padding-bottom: var(--ds-space-0, 0);
}
.aFGD9vtcIAqeiM.YzL7yRijWxDng8 {
  padding-top: var(--ds-space-0, 0);
}
.JABNldlIncwKgc {
  z-index: 2;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  border: none;
  background: transparent;
  color: var(--ds-icon-subtle, #626f86);
  cursor: pointer;
}
.JABNldlIncwKgc:hover {
  color: var(--ds-icon, #44546f);
}
.zrn4tJQdoA76rj {
  grid-column: 3;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--ds-radius-large, 8px);
  color: var(--ds-icon-subtle, #626f86);
}
.zrn4tJQdoA76rj:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.zrn4tJQdoA76rj:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.zrn4tJQdoA76rj.w2na5dRRFTiC5E {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  width: 40px;
  height: 40px;
}
.zrn4tJQdoA76rj.i5Eb6yRIY332IA {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .zrn4tJQdoA76rj.i5Eb6yRIY332IA {
  outline-color: -webkit-focus-ring-color;
}
.zrn4tJQdoA76rj.i5Eb6yRIY332IA .mac.firefox {
  outline-color: AccentColor;
}
.gX6LwzU7ABKW3h {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--ds-radius-large, 8px);
  color: var(--ds-icon-subtle, #626f86);
}
.gX6LwzU7ABKW3h:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.gX6LwzU7ABKW3h:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.gX6LwzU7ABKW3h.i5Eb6yRIY332IA {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .gX6LwzU7ABKW3h.i5Eb6yRIY332IA {
  outline-color: -webkit-focus-ring-color;
}
.gX6LwzU7ABKW3h.i5Eb6yRIY332IA .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
var _1 = `Tu0XvZVffeyqqw`;
export { _1 as "nch-popover" };
var _2 = `F4ycqeb62wUbQq`;
export { _2 as "nch-popover__header" };
export var UNSAFE_multilineTitle = `w2na5dRRFTiC5E`;
var _3 = `RXaG378ipXh0pB`;
export { _3 as "nch-popover__title" };
var _4 = `aFGD9vtcIAqeiM`;
export { _4 as "nch-popover__content" };
export var noHorizontalPadding = `BxnW01nt1ospt1`;
export var noBottomPadding = `uS2wuOb6bRMSqo`;
export var noTopPadding = `YzL7yRijWxDng8`;
var _5 = `JABNldlIncwKgc`;
export { _5 as "nch-popover__iconButton" };
var _6 = `zrn4tJQdoA76rj`;
export { _6 as "nch-popover__closeButton" };
export var hasFocusRing = `i5Eb6yRIY332IA`;
var _7 = `gX6LwzU7ABKW3h`;
export { _7 as "nch-popover__backButton" };
export default ___CSS_LOADER_EXPORT___;
